import axios from "axios";
// 使用element-ui Message做消息提醒
import { ElMessage, ElMessageBox } from "element-plus";
import cookie from "../assets/js/cookie";
import api from "@/api/ai_api";
let isRefreshToken = false
let requestList = []
//正式
const campusPath = '/campus';
//219
// const campusPath = '/campus2';

const getBaseUrl = (env) => {
  let base = {
    production: "/",
    development: "http://localhost:8080",
    test: "http://localhost:8080",
  }[env];
  if (!base) {
    base = "";
  }
  return base;
};
//1. 创建新的axios实例，
const service = axios.create({
  // 公共接口--这里注意后面会讲
  method: "POST",
  withCredentials: false,
  baseURL: getBaseUrl(process.env.BASE_API),
  // 超时时间 单位是ms，这里设置了300s的超时时间
  timeout: 300 * 1000,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    "Access-Control-Allow-Origin": "*",
  },
});
// 2.请求拦截器
service.interceptors.request.use(
  (config) => {
    //发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等，根据需求去添加
    // console.log(config.data);
    // config.data = JSON.stringify(config.data); //数据转化,也可以使用qs转换

    let college_user = cookie.getCookie("college_user");
    let userInfo = {};
    if (college_user && college_user != "undefined") {
      userInfo = JSON.parse(college_user);
    }
    let contentType = "application/x-www-form-urlencoded;";
    if (config.url.indexOf("add_front_learn_resource_record") >= 0 ||
      config.url.indexOf("/personnelapi/add_pUserCertificate") >= 0 ||
      config.url.indexOf("/personnelapi/query_front_skill_train_statistics") >= 0 ||
      config.url.indexOf("/competitionapi/register") >= 0 ||
      config.url.indexOf("/personnelapi/add_front_question_resource_record") >= 0
    ) {
      contentType = "application/json;charset=UTF-8";
      config.data = JSON.stringify(config.params);
      config.params = null;
    }
    if (config.url.indexOf("/query_teacher_home_view_report_pdf") >= 0) {
      contentType = "multipart/form-data";
      config.data = config.params;
      config.transformRequest = [function () {
        return config.params;
      }]
    }
    if (config.data && config.data != null) {
      contentType = "application/json;charset=UTF-8";
    }
    config.headers = {
      //     // 设置后端需要的传参类型
      token: cookie.getCookie("college_token"),
      collegetoken: cookie.getCookie("college_token"),
      pccollege: userInfo && userInfo.college ? userInfo.college : "",
      // "pccollege": userInfo.college,
      "Content-Type": contentType,
      Authorization: 'Bearer ' +cookie.getCookie("ai_token"),
      'tenant-id': cookie.getCookie("tenant_id"),
      //     "Access-Control-Allow-Origin": "*"
      //     //     "pccollege": JSON.parse(getCookie("college_user")).college,
      //     //     "collegetoken": getCookie('college_token'),
    };
    //如有需要：注意使用token的时候需要引入cookie方法或者用本地localStorage等方法，推荐js-cookie
    // const token = getCookie('college_token');//这里取token之前，你肯定需要先拿到token,存一下
    // if (token) {
    //     config.params = { 'token': token } //如果要求携带在参数中
    //     config.headers.token = token; //如果要求携带在请求头中
    // }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
const isRelogin = { show: false }

// 添加响应拦截器
service.interceptors.response.use(
  async function (response) {
    const dataAxios = response.data;
    const config = response.config;
    const code = dataAxios.code;
    if (code === 401) {
      // 如果未认证，并且未进行刷新令牌，说明可能是访问令牌过期了
      if (!isRefreshToken) {
        isRefreshToken = true
        // 1. 如果获取不到刷新令牌，则只能执行登出操作
        if (!cookie.getCookie("ai_refreshToken")) {
          // locationHref();
          handleAuthorized()
        }
        // 2. 进行刷新访问令牌
        try {
          let refreshTokenRes = await api.refreshToken(cookie.getCookie("ai_refreshToken"));
          let refreshTokenResData = refreshTokenRes.data;
          // 2.1 刷新成功，则回放队列的请求 + 当前请求
          cookie.setCookie("ai_token",refreshTokenResData.accessToken);
          cookie.setCookie("ai_refreshToken",refreshTokenResData.refreshToken);
          config.headers.Authorization = 'Bearer ' + refreshTokenResData.accessToken
          requestList.forEach((cb) => {
            cb()
          })
          requestList = []
          return service(config)
        } catch (e) {
          // 为什么需要 catch 异常呢？刷新失败时，请求因为 Promise.reject 触发异常。
          // 2.2 刷新失败，只回放队列的请求
          requestList.forEach((cb) => {
            cb()
          })
          // 提示是否要登出。即不回放当前请求！不然会形成递归
          // locationHref()
          handleAuthorized()
        } finally {
          requestList = []
          isRefreshToken = false
        }
      } else {
        // 添加到队列，等待刷新获取到新的令牌
        return new Promise((resolve) => {
          requestList.push(() => {
            config.headers.Authorization = 'Bearer ' + cookie.getCookie("ai_token") // 让每个请求携带自定义token 请根据实际情况自行修改
            resolve(service(config))
          })
        })
      }
    }
    if (dataAxios.errorcode == "e0001" || dataAxios.errorcode == "e0003") {
      ElMessage.error(dataAxios.msg);
      cookie.clearCookies();
      locationHref();
    } else if (dataAxios.errorcode == "e2006") {
      ElMessage.error(dataAxios.msg);
    } else {
      if (dataAxios.status === 1) {
        let msg = dataAxios.msg || "";
        if (msg && msg.length > 0) {
          if (msg.indexOf("登录已失效") >= 0) {
            cookie.clearCookies();
            locationHref();
          }
        }
        ElMessage.error(dataAxios.msg);
      }
    }
    return dataAxios;
  },
  function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    // console.log(error);
    //     /***** 接收到异常响应的处理开始 *****/
    if (error && error.response) {
      // 1.公共错误处理
      // 2.根据响应码具体处理
      switch (error.response.status) {
        case 400:
          error.message = "错误请求";
          break;
        case "e0003":
          error.message = "登录已失效，请重新登录";
          cookie.clearCookies();
          locationHref();
          break;
        case 403:
          error.message = "拒绝访问";
          break;
        case 404:
          error.message = "请求错误,未找到该资源";
          // window.location.href = "/NotFound"
          //window.location.href = campusPath
          break;
        case 405:
          error.message = "请求方法未允许";
          break;
        case 408:
          error.message = "请求超时";
          break;
        case 500:
          error.message = "服务器端出错";
          break;
        case 501:
          error.message = "网络未实现";
          break;
        case 502:
          error.message = "网络错误";
          break;
        case 503:
          error.message = "服务不可用";
          break;
        case 504:
          error.message = "网络超时";
          break;
        case 505:
          error.message = "http版本不支持该请求";
          break;
        default:
          error.message = `连接错误${error.response.status}`;
      }
    } else {
      // 超时处理
      if (JSON.stringify(error).includes("timeout")) {
        ElMessage.error("服务器响应超时，请刷新当前页");
      }
      error.message = "连接服务器失败";
    }
    // return Promise.reject(error)
    // ElMessage.error(error.message);
    /***** 处理结束 *****/
    //如果不需要错误处理，以上的处理过程都可省略
    return Promise.resolve(error.response);
  }
);

function handleAuthorized() {
  if (!isRelogin.show) {
    isRelogin.show = true
    ElMessageBox.confirm("登录超时,请重新登录!","提示", {
      showCancelButton: false,
      closeOnClickModal: false,
      showClose: false,
      closeOnPressEscape: false,
      confirmButtonText: '重新登录',
      type: 'warning'
    }).then(() => {
      isRelogin.show = false
      cookie.clearCookies();
      locationHref();
      // 干掉token后再走一次路由让它过router.beforeEach的校验
      // window.location.href = window.location.href
      // window.location.reload()
    })
  }
}

function locationHref() {
  let college = "";
  let collegeConfig = JSON.parse(
    sessionStorage.getItem("kSysCollegeConfig")
  );
  if (collegeConfig != null && Object.keys(collegeConfig).length > 0) {
    if (collegeConfig.collegetag) {
      college = collegeConfig.collegetag;
    }
  }
  let pathname = window.location.pathname;
  let path = "";
  if (pathname) {
    if (pathname.indexOf("/campus/") >= 0) {
      path = "/campus";
    } else if (pathname.indexOf("/campus2/") >= 0) {
      path = "/campus2";
    }
  }
  let url = `${window.location.origin}${path}`;
  if (!college) {
    window.location.href = url;
  } else {
    window.location.href = `${url}?college=${decodeURIComponent(
      college
    )}`;
  }
  sessionStorage.removeItem("kSysCollegeConfig");
}

//4.导入文件
export default service;